import React from 'react';

import {PlaceholderWrapperComponent} from "../../../../../core/components/placeholder/placeholder-wrapper";
import styles from "../../../styles/athlete-widget.placeholder.module.scss"
import classNames from "classnames";
import {AthleteWidgetSubDetailsPlaceholder} from "./athlete-widget.sub-details.placeholder";
import {AthleteWidgetEntitiesDetailsPlaceholder} from "./athlete-widget.entities-details.placeholder";

export const AthleteWidgetDetailsPlaceholder = ({device}) => {
  const {isSmallView} = device;

  return (
    <PlaceholderWrapperComponent className={classNames(styles.details_container, {[styles.small_view]: isSmallView})}>
      <div className={classNames(styles.details_content, {[styles.small_view]: isSmallView})}>
        <AthleteWidgetEntitiesDetailsPlaceholder device={device}/>
        <div className={classNames(styles.horizontal_divider)}/>
        <AthleteWidgetSubDetailsPlaceholder device={device}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
